import { ThemeProperties } from '../../../core';

export interface LabelTheme {
	baseFont: string;
	baseTextColor: string;
	optionalFont: string;
	optionalTextColor: string;
}
export const theme = new ThemeProperties('label');
